var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notices-container"},[_vm._v("Notices")])
}
var staticRenderFns = []

export { render, staticRenderFns }